// Configurations/WaitingJobsConfig.jsx
import React from 'react';
import {
  dataGridDateSorter,
  dataGridNumberSorter,
  dataGridTextSorter,
} from '../../../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { IconButton } from '../../../../../../common/controls/Controls.jsx';
import {
  DislikeOutlined,
  LikeOutlined,
  FileSearchOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { routes } from '../../../../../../../utils/helpers/ApiClient.jsx';
import { QuestionModal } from '../../../../../../common/index.jsx';
import { Tag } from 'antd';
import { statusColorJob } from '../../../../../../../utils/constants/enums.js';

export const WaitingJobsConfig = ({
  t,
  navigate,
  permissions,
  handlers,
  filterHooks,
}) => {
  return {
    columns: [
      {
        title: t('Názov'),
        dataIndex: 'name',
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        ...filterHooks.nameTextFilterProps,
      },
      {
        title: t('Lektor'),
        dataIndex: 'supervisor_full_name',
        ellipsis: true,
        sorter: dataGridTextSorter('supervisor_full_name'),
        ...filterHooks.supervisorTextFilterProps,
      },
      {
        title: t('Začiatok'),
        dataIndex: 'date_from',
        sorter: dataGridDateSorter('date_from'),
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        ...filterHooks.fromDateRangeFilterProps,
      },
      {
        title: t('Koniec'),
        dataIndex: 'date_to',
        sorter: dataGridDateSorter('date_to'),
        render: (date) => (date && new Date(date).toLocaleDateString()) || '-',
        ...filterHooks.toDateRangeFilterProps,
      },
      {
        title: t('Kapacita'),
        dataIndex: 'student_capacity',
        sorter: dataGridNumberSorter('student_capacity'),
      },
      {
        title: t('Stav'),
        dataIndex: 'status',
        sorter: dataGridTextSorter('status'),
        ...filterHooks.statusTextFilterProps,
        render: (status) => (
          <Tag color={statusColorJob(status)}>{t(status)}</Tag>
        ),
      },
    ],

    customActions: (record) => (
      <div style={{ display: 'flex' }}>
        {permissions.isFijAdmin && (
          <>
            <IconButton
              icon={<EditOutlined />}
              tooltip={t('Upraviť')}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`${routes.cmsFijJobEdit}/${record.id}`);
              }}
            />
            <IconButton
              icon={<FileSearchOutlined />}
              tooltip={t('Zobraziť detail')}
              onClick={(e) => {
                e.stopPropagation();
                navigate(`${routes.cmsFijJobDetail}/${record.id}`);
              }}
            />
            <IconButton
              icon={<LikeOutlined />}
              tooltip={t('Schváliť FRI prax')}
              onClick={(e) => {
                e.stopPropagation();
                handlers.openApproveModal(record);
              }}
            />
            <IconButton
              icon={<DislikeOutlined />}
              tooltip={t('Zamietnuť FRI prax')}
              onClick={(e) => {
                e.stopPropagation();
                handlers.openRejectModal(record);
              }}
            />
          </>
        )}
      </div>
    ),

    modals: ({ modalState, closeModal, onConfirm }) => (
      <>
        <QuestionModal
          chosenPositive={onConfirm}
          question={t('Naozaj chcete schváliť túto FRI prax?')}
          visible={modalState.type === 'approve'}
          yes={t('Áno')}
          toggle={closeModal}
          headerTitle={t('Schváliť FRI prax')}
        />
        <QuestionModal
          chosenPositive={onConfirm}
          question={t(
            'Naozaj chcete zamietnuť túto FRI prax? Po zamietnutí sa FRI prax uloží do archívu.',
          )}
          visible={modalState.type === 'reject'}
          yes={t('Áno')}
          toggle={closeModal}
          headerTitle={t('Zamietnuť FRI prax')}
        />
      </>
    ),
  };
};
